// Recarga da página quando um chunk de rota some do servidor.
//
// Cada build gera nomes com hash (`NovoProcessoPage-BxTp2W5c.js`), e o deploy troca os arquivos
// de `assets/`. Quem estava com a aba aberta antes do deploy continua executando o bundle antigo,
// que pede ao servidor um chunk que não existe mais — e a navegação morre com
// "Failed to fetch dynamically imported module". Uma recarga resolve: o index.html novo aponta
// para os chunks novos.
//
// O erro chega por DOIS caminhos, e os dois precisam ser cobertos:
// - `router.onError`, quando o `import()` da rota falha;
// - o evento `vite:preloadError`, que o Vite dispara quando falha o pré-carregamento de uma
//   dependência do chunk (JS ou CSS) — inclusive fora do router, em `defineAsyncComponent`.

const CHAVE = 'recarga_por_chunk'

// Uma recarga basta quando o problema é aba antiga. Se, recarregada, a página pedir de novo um
// chunk que não existe, o defeito é do deploy — recarregar outra vez só entraria em loop.
const JANELA_SEM_NOVA_RECARGA_MS = 30_000

let recarregando = false

const MENSAGENS_DE_CHUNK = [
  'Failed to fetch dynamically imported module', // Chrome, Edge
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari
  'Unable to preload CSS' // preload do Vite
]

export function ehErroDeChunk(error) {
  const mensagem = error?.message ?? ''

  return error?.name === 'ChunkLoadError' || MENSAGENS_DE_CHUNK.some((m) => mensagem.includes(m))
}

// O retorno do Keycloak (`#state=...&code=...`) fica no fullPath da primeira rota. Recarregar com
// ele reapresentaria ao Keycloak um código de autorização já usado.
function semRetornoDoLogin(destino) {
  const [caminho, hash] = destino.split('#')

  return hash && /(^|&)(state|code|session_state)=/.test(hash) ? caminho : destino
}

function recargaRecente() {
  try {
    const ultima = Number(sessionStorage.getItem(CHAVE))

    return Number.isFinite(ultima) && Date.now() - ultima < JANELA_SEM_NOVA_RECARGA_MS
  } catch {
    return false
  }
}

/**
 * Recarrega a página em `destino` para buscar a versão publicada. Devolve `false` quando já houve
 * uma recarga há pouco — aí o chunk falta mesmo com o index.html novo, e o erro é real.
 */
export function recarregarParaVersaoNova(destino = window.location.href) {
  if (recarregando) {
    return true
  }

  if (recargaRecente()) {
    return false
  }

  try {
    sessionStorage.setItem(CHAVE, String(Date.now()))
  } catch {
    // Sem sessionStorage não há como evitar o loop; melhor deixar o erro aparecer
    return false
  }

  recarregando = true
  window.location.assign(semRetornoDoLogin(destino))

  return true
}

/**
 * `true` enquanto a página está saindo para recarregar. O ErrorReportingService usa isto para
 * não mandar ao Teams um erro que a recarga já está resolvendo.
 */
export function recargaEmAndamento() {
  return recarregando
}

export function instalarRecargaPorChunk() {
  window.addEventListener('vite:preloadError', () => {
    // Sem preventDefault: o erro segue para quem fez o import (o router, por exemplo), que
    // encontra a recarga já em andamento. Com preventDefault o import resolveria `undefined`, e
    // o router falharia com outro erro, que não parece de chunk.
    recarregarParaVersaoNova()
  })
}
